import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { URL } from "../../Redux/common/url";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
function CategoryList() {
  const all_categories_List = useSelector((state) =>
    state?.allapi?.all_categories_List ? state?.allapi?.all_categories_List : []
  );

  const navigate = useNavigate();
  const [activeCate, setactiveCate] = useState(0);
  const [subCate, setsubCate] = useState([]);
  console.log(subCate);

  useEffect(() => {
    if (all_categories_List?.length > 0) {
      setsubCate(all_categories_List[0]?.subcates);
    }

    return () => {};
  }, [all_categories_List]);

  const hendleTochangeCate = (i) => {
    setactiveCate(i);
    setsubCate(all_categories_List[i]?.subcates);
  };
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <div className="AppPro">
      <div className="CategoryListapp">
        <div class=" mt-4">
          <div class="d-flex justify-content-around mb-3 cateLi">
            {all_categories_List &&
              all_categories_List?.map((data, i) => {
                return (
                  <button
                    onClick={() => {
                      hendleTochangeCate(i);
                    }}
                    class={
                      activeCate == i
                        ? "fts tab-btn btn btn-light active position-relative"
                        : "tab-btn btn btn-light fts  position-relative"
                    }
                  >
                    <img
                      src={URL?.API_BASE_URL + data?.image}
                      alt={data?.name}
                      className={` blur-image ${isLoaded ? "hide" : ""}`}
                      style={{
                        filter: "blur(10px)",
                        transition: "opacity 0.3s ease-in-out",
                        opacity: isLoaded ? 0 : 1,
                      }}
                    />
                    <LazyLoadImage
                      alt={"slider" + i}
                      // width={imageWidth}
                      // height={imageHeight}
                      // className="rounded-circle"
                      delayTime={300}
                      onLoad={() => setIsLoaded(true)}
                      style={{
                        transition: "opacity 0.3s ease-in-out",
                        opacity: isLoaded ? 1 : 0,
                      }}
                      src={URL?.API_BASE_URL + data?.image} // use normal <img> attributes as props
                    />
                    {data?.name}
                  </button>
                );
              })}
            {/* <button class="tab-btn btn btn-light">
              <img src="https://via.placeholder.com/30" alt="Women" />
              Women
            </button>
            <button class="tab-btn btn btn-light">
              <img src="https://via.placeholder.com/30" alt="Men" />
              Men
            </button>
            <button class="tab-btn btn btn-light">
              <img src="https://via.placeholder.com/30" alt="Kids" />
              Kids
            </button>
            <button class="tab-btn btn btn-light">
              <img src="https://via.placeholder.com/30" alt="Home" />
              Home
            </button> */}
          </div>

          <div class="d-flex text-center CategoryListr">
            {subCate &&
              subCate?.map((data, i) => {
                return (
                  <div
                    class="col-3 position-relative"
                    onClick={() =>
                      navigate(`/sub-category-product/${data?.cate_sulg}`)
                    }
                  >
                    <img
                      src={"/fav.png"}
                      alt={data?.name}
                      className={` blur-image ${isLoaded ? "hide" : ""}`}
                      style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "40px",
                        boxShadow: "3px 2px 20px #ffffff",
                        marginTop: "10px",
                        filter: "blur(10px)",
                        transition: "opacity 0.3s ease-in-out",
                        opacity: isLoaded ? 0 : 1,
                      }}
                    />
                    <LazyLoadImage
                      alt={"slider" + i}
                      // width={imageWidth}
                      // height={imageHeight}
                      // className="rounded-circle"
                      delayTime={300}
                      onLoad={() => setIsLoaded(true)}
                      style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "40px",
                        boxShadow: "3px 2px 20px #ffffff",
                        marginTop: "10px",
                        transition: "opacity 0.3s ease-in-out",
                        opacity: isLoaded ? 1 : 0,
                      }}
                      src={URL?.API_BASE_URL + data?.image} // use normal <img> attributes as props
                    />
                    <p
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontSize: "11px",
                      }}
                    >
                      {data?.name}
                    </p>
                  </div>
                );
              })}
            {/* <div class="col-3">
              <img src="https://via.placeholder.com/80" alt="Westernwear" />
              <p>Westernwear</p>
            </div>
            <div class="col-3">
              <img src="https://via.placeholder.com/80" alt="Indianwear" />
              <p>Indianwear</p>
            </div>
            <div class="col-3">
              <img src="https://via.placeholder.com/80" alt="Footwear" />
              <p>Footwear</p>
            </div>
            <div class="col-3">
              <img src="https://via.placeholder.com/80" alt="Winterwear" />
              <p>Winterwear</p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CategoryList;
